import { jsx as _jsx } from "react/jsx-runtime";
import { Divider as HeroDivider } from '@heroui/react';
export const Divider = (props) => {
    return _jsx(HeroDivider, { ...props });
};
export default Divider;
//# sourceMappingURL=Divider.js.map